/** Discovery-only stock policy. Product URLs and the saved wishlist stay addressable. */
(() => {
  const availability = 'filter.v.availability';
  const isDiscoveryPath = (pathname) => /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[^/]+\/?|search\/?)$/i.test(pathname);

  /** @param {URLSearchParams} parameters */
  function normalizeParameters(parameters) {
    parameters.set(availability, '1');
    return parameters;
  }

  /** @param {string | URL} input @param {string | URL} base */
  function normalizeURL(input, base) {
    const origin = new URL(base);
    const url = new URL(input, origin);
    if (url.origin === origin.origin && isDiscoveryPath(url.pathname)) {
      normalizeParameters(url.searchParams);
      if (/\/search\/?$/.test(url.pathname)) url.searchParams.set('options[unavailable]', 'hide');
    }
    return url;
  }

  globalThis.EkStockPolicy = Object.freeze({ normalizeParameters, normalizeURL, isDiscoveryPath });
  if (typeof document === 'undefined') return;

  // The inline head guard handles direct loads before paint. Recheck history
  // restores here; Shopify applies the query before native pagination.
  const normalizeLocation = () => {
    const normalized = normalizeURL(location.href, location.href);
    if (normalized.href !== location.href) location.replace(normalized.href);
  };
  normalizeLocation();
  addEventListener('popstate', normalizeLocation);
  addEventListener('pageshow', normalizeLocation);

  // Native navigation keeps modifier keys, target, locale, hash and pagination.
  // This also covers cards/links inserted by section rendering.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const anchor = event.target.closest('a[href]');
    if (!(anchor instanceof HTMLAnchorElement) || anchor.hasAttribute('download')) return;
    const normalized = normalizeURL(anchor.href, location.href);
    if (normalized.href !== anchor.href) anchor.href = normalized.href;
  }, true);
})();
